import { createApiHooks } from '@apis/next/common';
import { BookingInquiryLog } from '@models/next/BookingInquiryLog';
import { makeApi } from '@zodios/core';
import { z } from 'zod';

const apis = makeApi([
  {
    method: 'get',
    path: '/:d2d_no/logs',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: BookingInquiryLog.array(),
  },
]);

export const dashboardBookingInquiryLogApis = createApiHooks('/dashboard/booking-inquiry', apis);

export const bookingInquiryLogApis = createApiHooks('/booking-inquiry', apis);
